export default __webpack_public_path__ + "static/media/logo.93ac40c2.png";